import { KashilandLogo } from '@/components';

const FooterHeader = () => (
  <div className='space-y-4'>
    <KashilandLogo className='lg:w-48' />
  </div>
);

export { FooterHeader };
